import React from 'react'
import Heading from '../../../../../components/heading/Heading';
import { HEADING } from '../../../../../components/heading/constants/constants';
import CardWIconTitleAndButton from '../../../../../components/card/CardWIconTitleAndButton/CardWIconTitleAndButton';
import styles from "./GetRequestType.styles"
import { REQUEST_TYPE } from './constants';
import commonStyles from "../../AddRecipient.styles";

export default function GetRequestType({
    onCardClickCb = () => { },
    type = "",
    renderForSingleView = false,
}) {

    return (
        <>
            <div style={commonStyles.container}>
                <div>
                    <Heading type={HEADING.H1}>Please select the type of request (optional)</Heading>
                </div>

                <div style={commonStyles.cardsGroupContainer}>

                    {
                        REQUEST_TYPE.map((card, idx) => (

                            <div style={commonStyles.cardContainer} onClick={() => onCardClickCb(card)}>
                                <CardWIconTitleAndButton
                                    title={card.title}
                                    icon={card.icon}
                                    customStyles={{...styles.individualCardStyle, ...(renderForSingleView ? styles.singleViewIndividualCardStyle : {})}}
                                    isHighlighted={type === card.title ? true : false}
                                    justifyContent="center"
                                    headerCustomStyles={{...styles.cardHeader, ...(renderForSingleView ? styles.singleViewCardHeader : {})}}
                                />
                            </div>

                        ))
                    }

                </div>
            </div>
        </>
    )
}